export type MarketingWorkflowContext = {
    greeting: string
    enabled: boolean
    application?: string
    plan?: string
}

export const useMarketingWorkflow = () => {

    const context = {
        greeting: 'Welcome',
        enabled: false,
        planId: ''
    }

    return {
        context,
    };
};
